import {Checkbox as MUICheckbox, CheckboxProps} from '@mui/material';
import {
  CheckCircleRounded,
  CheckCircleOutline,
  RadioButtonUncheckedRounded,
} from '@mui/icons-material';

export const Checkbox = (props: CheckboxProps) => {
  return (
    <MUICheckbox
      indeterminateIcon={<CheckCircleOutline />}
      checkedIcon={<CheckCircleRounded />}
      icon={<RadioButtonUncheckedRounded />}
      sx={{
        width: '16px',
        height: '16px',
        padding: 0,
        color: 'var(--dcm-blue-base)',
      }}
      {...props}
    />
  );
};
